import React from "react";
import { addToCart } from "../../../store/cart.slice";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const ProductCard = ({ product, pathName }) => {
  const dispatch = useDispatch();

  const handleAddToCart = () => {
    toast.success("Product added", {
      autoClose: 1000,
      position: "bottom-right",
    });

    dispatch(addToCart(product));
  };

  // Définir les classes de colonnes en fonction du pathName
  const columnClass = pathName === "/market-place" ? "col-xl-2-4 col-lg-3 col-xxl-2#" : "col-xxl-2-4# col-xl-3 col-md-4";

  return (
    <div className={`${columnClass}  col-sm-6 col-md-4 col-xs-12 mb-4 `}>
      {/* { product.stock !== "0" && ( */}
         <div className=" card card-bordered shadow-none p-2 ">
         <div className="  py-2 ">
           <Link
             className="text-dark "
             to={`/market-place/product-details/${encodeURIComponent(btoa(product.id))}`}
           >
             <img
             
               className="card-img "
               src={product.image[0].url}
               alt="Product"
               height={150}
               width={"100%"}
             />
           </Link>
 
           <div className="card-pinned-top-end">
             <button
               type="button"
               className="btn btn-outline-secondary btn-xs btn-icon rounded-circle"
               data-bs-toggle="tooltip"
               data-bs-placement="top"
               title="Save for later"
             >
               <i className="bi-heart"></i>
             </button>
           </div>
         </div>
 
         <div className="card-body## mt-0 p-3### py-2">
           {product.category && (
             <div className="mb-2">
               <Link
                 className="link-sm link-secondary"
                 to={`/market-place/category/${encodeURIComponent(btoa(product.category.id))}`}
               >
                 {product.category.name}
               </Link>
             </div>
           )}
 
           <Link
             className="text-dark "
             to={`/market-place/product-details/${encodeURIComponent(btoa(product.id))}`}
           >
             <h5 className="card-title fw-normal fs-6 btn-link ">
               {product.name}
             </h5>
           </Link>
         </div>
 
         <div className="card-footer## pb-4## pt-1 d-flex align-items-center justify-content-between ">
           <span className="card-text text-primary btn-link fw-bold fs-4 ms-2#">
             ${product.price}
           </span>
           <button
             className="btn btn-outline-primary btn-sm "
             disabled={product.stock === 0}
             onClick={handleAddToCart}
           >
             <HiOutlineShoppingCart /> {" "}
             
           </button>
         </div>
       </div>
       {/* )} */}
     
    </div>
  );
};

export default ProductCard;

function HiOutlineShoppingCart(props) {
  return (
    <svg
      stroke="currentColor"
      fill="none"
      strokeWidth={0}
      viewBox="0 0 24 24"
      height="1.3em"
      width="1.3em"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
      />
    </svg>
  );
}
